var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"fullloader"},[_vm._v(" 読み込み中です... ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }